import React from "react";
import { useCourseProposals } from "./UseCourseProposals";
import ClientCourseProposals from "./ClientCourseProposals";

interface Props {
  punctualId: number;
  clientId?: number;
  toggleRow: (id: number) => void;
  activeRow: number | null;
  load: boolean;
  setLoad: React.Dispatch<React.SetStateAction<boolean>>;
  isHome?: boolean;
  duration: number;
  refetchCourses?: () => void;
}

const FetchCoursProposals = ({ punctualId, load, setLoad, duration,refetchCourses }: Props ) => {
  const proposals = useCourseProposals(punctualId, load, setLoad);

  if (load) return <p>Loading proposals...</p>;
  if (!proposals.length)
    return <p>Aucune proposition de cours pour le moment.</p>;

  return (
    <div className="overflow-x-auto">
      <ClientCourseProposals
        proposals={proposals}
        duration={duration}
        refetchCourses={refetchCourses}
      />
    </div>
  );
};

export default FetchCoursProposals;